// eslint-disable-next-line @typescript-eslint/no-var-requires
const _ = require('lodash');

const getOutputChannel = () => {
  switch (process.env.NEXT_PUBLIC_DOMAIN) {
    case 'usa':
      return 'en_US';
    case 'australia':
      return 'en_AU';
    case 'europe':
      return 'de_DE';
    default:
      throw new Error('Invalid NEXT_PUBLIC_DOMAIN value: ' + process.env.NEXT_PUBLIC_DOMAIN);
  }
};

const getDomainUrl = () => {
  const url = process.env.NEXT_PUBLIC_VERCEL_URL;

  if (!url) {
    throw new Error('Invalid NEXT_PUBLIC_VERCEL_URL value: ' + url);
  }

  if (!url.includes('http')) {
    return 'https://' + url;
  }

  return url;
};

const getAppEnv = () => {
  const appEnv = process.env.NEXT_PUBLIC_APP_ENV;

  if (!_.includes(['production', 'staging', 'test', 'local'], appEnv)) {
    throw new Error('Invalid NEXT_PUBLIC_APP_ENV value: ' + appEnv);
  }

  return appEnv;
};

const getDomainsUrls = () => {
  const appEnv = getAppEnv();

  switch (appEnv) {
    case 'local':
      return {
        europe_url: 'http://localhost:3000',
        australia_url: 'https://www.walterknoll.com.au',
        usa_url: 'https://www.walter-k.com',
      };
    case 'production':
      return {
        europe_url: 'https://www.walterknoll.de',
        australia_url: 'https://www.walterknoll.com.au',
        usa_url: 'https://www.walter-k.com',
      };
    case 'staging':
      return {
        europe_url: 'https://staging-walter-knoll.hyam.berlin',
        australia_url: 'https://staging-walter-knoll-australia.hyam.berlin',
        usa_url: 'https://staging-walter-knoll-usa.hyam.berlin',
      };
    case 'test':
      return {
        europe_url: 'https://test-walter-knoll.hyam.berlin',
        australia_url: 'https://test-walter-knoll-australia.hyam.berlin',
        usa_url: 'https://test-walter-knoll-usa.hyam.berlin',
      };
  }
};

module.exports = { getOutputChannel, getDomainUrl, getAppEnv, getDomainsUrls };
